'use client'

import type { ScrollingIndicatorProps } from '@pearlconvert/ui/components/carousel/carousel.types'

import { useTranslations } from 'next-intl'

import { useScrollingIndicator } from '@pearlconvert/ui/components/carousel/batons/use-scrolling-indicator'

import '@pearlconvert/ui/components/carousel/styles/indicator.scss'

export default function ScrollingIndicator({
  carouselRef,
  caruselItems,
  className,
  goToSlide,
  isLoading,
  noWrap = false,
  slideCount,
  slideIndex,
  slidesPerView,
  carouselName,
}: ScrollingIndicatorProps) {
  const t = useTranslations('ui')
  const { fullSlideWidth, indicatorWidth, lastSlideWidth, scrollbarPosition } =
    useScrollingIndicator({
      carouselRef,
      caruselItems,
      isLoading,
      noWrap,
      slideCount,
      slideIndex,
      slidesPerView,
    })

  return (
    <div
      className={`slide__progress-navigation${
        className ? ' ' + className : ''
      }`}
      role="group"
    >
      <span
        className="slide__progress-indicator"
        aria-hidden={true}
        style={{
          left: `${scrollbarPosition}%`,
          right: `${100 - scrollbarPosition - indicatorWidth}%`,
        }}
      ></span>

      {!isLoading &&
        [...Array(slideCount)].map((_, index) => {
          const isLastSlide = index === slideCount - 1
          const buttonWidth = noWrap
            ? null
            : isLastSlide
              ? lastSlideWidth
              : fullSlideWidth

          const buttonLabel = carouselName
            ? `${carouselName}, ${t('carousel.show-slide', {
                index: index + 1,
                count: slideCount,
              })}`
            : t('carousel.show-slide', {
                index: index + 1,
                count: slideCount,
              })

          return (
            <button
              key={index}
              className="slide__progress-control"
              aria-disabled={index === slideIndex}
              aria-label={buttonLabel}
              onClick={() => goToSlide(index)}
              style={{ width: `${buttonWidth}%` }}
            ></button>
          )
        })}
    </div>
  )
}
